import {config} from '@app/cuss/embross/utils/config';
import { TraceLevels, ApplicationState, DeviceManager } from 'src/embross-device-manager';

export default class OosManager {
    devMgr: DeviceManager;
    isDevicesOK
    isHostOK
    inService
    appState
    checkDeviceInterval
    checkDeviceIntervalActive
    isHeartbeatRequired
    heartbeatUrl
    noWebsocket
    constructor(devMgr: DeviceManager, checkDeviceInterval: number, checkDeviceIntervalActive: number, isHeartbeatRequired = false) {
        this.devMgr = devMgr;
        this.isDevicesOK = false;
        this.isHostOK = !isHeartbeatRequired;
        this.inService = false;
        this.isHeartbeatRequired = isHeartbeatRequired;
        this.appState = this.devMgr.getAppManager().currentState;
        this.checkDeviceInterval = checkDeviceInterval;
        this.checkDeviceIntervalActive = checkDeviceIntervalActive;
        this.heartbeatUrl = '';
        this.noWebsocket = !config.isCUSSRequired;
    }

    statusChangeListener = (deviceId, event) => {
        this.devMgr.getAppManager().setState(4)
        this.appState = this.devMgr.getAppManager().currentState;
        if (event.key === 'statusIsOK') {
            if (this.devMgr.areAllRequiredDevicesOK(false)) {
                this.isDevicesOK = true;
            } else {
                this.isDevicesOK = false;
            }
            if (this.isHeartbeatRequired) {
                if (this.isDevicesOK && this.isHostOK) {
                    if (this.appState < ApplicationState.AVAILABLE) {
                        this.inService = true;
                        this.devMgr.getAppManager().available();
                    }
                } else {
                    if (this.appState >= ApplicationState.AVAILABLE) {
                        this.inService = false;
                    }
                }
            } else {
                if (this.isDevicesOK) {
                    if (this.appState < ApplicationState.AVAILABLE) {
                        this.inService = true;
                        this.devMgr.getAppManager().available();
                    }
                } else {
                    if (this.appState >= ApplicationState.AVAILABLE) {
                        this.inService = false;
                    }
                }
            }
        }
    }

    onHeartbeatSuccess = (response) => {
        if (response.inService) {
            this.devMgr.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_UP');
            this.isHostOK = true;
        } else {
            this.onHeartbeatFail();
        }
    };

    onHeartbeatFail = () => {
        this.isHostOK = false;
        this.devMgr.appManager.sendApplicationLog(100, 'CDS_HOSTSTAT,HOSTSTAT_DOWN');
    };

    checkDevices = () => {
        const devices = this.devMgr.devices;
        this.devMgr.getAppManager().getCurrentState(false, !config.isCUSSRequired);
        for (let i = 0; i < devices.length; i++) {
            devices[i].statusIsOK(false);
        }
        const appState = this.devMgr.getAppManager().currentState;
        if (this.isHeartbeatRequired) {
            if (this.heartbeatUrl !== '') {
            } else {
            }
        }
        const intervalValue =
            appState === ApplicationState.ACTIVE ? this.checkDeviceIntervalActive : this.checkDeviceInterval;
        setTimeout(() => {
            this.checkDevices();
        }, intervalValue * 1000);
    };

    start = () => {
        let devices = this.devMgr.devices;
        for (let i = 0; i < devices.length; i++) {
            devices[i].addListener(devices[i].deviceId, this.statusChangeListener);
        }
        this.devMgr.getAppManager().getCurrentState(false, !config.isCUSSRequired);
        this.checkDevices();
    };

    /** Complete the CUSS transaction. If the application is ready for the next user, it will go available. Otherwise,
     it will go unavailable. (Note that only devices are checked at this point, not the heartbeat.)
     @param {boolean} [forceUnavailable] if true, the application will go unavailable immediately, even if
     devices are showing up OK.
     */
    completeTransaction = (forceUnavailable) => {
        this.devMgr.dmLog(TraceLevels.LOG_SYSTEM, 'OOS.completeTransaction start forceUnavailable: ' + forceUnavailable);
        if (this.noWebsocket === true) {
            this.devMgr.dmLog(TraceLevels.LOG_SYSTEM, 'OOS.completeTransaction exit: noWebsocket === true');
            return;
        }

        let appMan = this.devMgr.getAppManager();
        this.devMgr.dmLog(TraceLevels.LOG_TRACE, '.OOS.completeTransaction app manager.');
        if (this.inService && !forceUnavailable) {
            this.devMgr.dmLog(TraceLevels.LOG_TRACE, '.OOS.completeTransaction() called. Going available.');
            
        } else {
            if (forceUnavailable) {
                this.isDevicesOK = false; 
                this.inService = false;
                this.devMgr.dmLog(
                    TraceLevels.LOG_TRACE,
                    '.OOS.completeTransaction() called. Forcing app into unavailable state.'
                );
            } 
            else {
                if (this.isHeartbeatRequired) {
                   
                }
                if (!this.isHostOK) {
                    if (!this.isDevicesOK) {
                        this.devMgr.dmLog(
                            TraceLevels.LOG_TRACE,
                            '.OOS.completeTransaction() called. Devices and heartbeat not OK, going unavailable.'
                        );
                    } else {
                        this.devMgr.dmLog(
                            TraceLevels.LOG_TRACE,
                            '.OOS.completeTransaction() called. Heartbeat not OK, going unavailable.'
                        );
                    }
                } else {
                    this.devMgr.dmLog(
                        TraceLevels.LOG_TRACE,
                        '.OOS.completeTransaction() called. Devices not OK, going unavailable.'
                    );
                }
            }
        }
    }
}